define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MDppDensityDomain = void 0;
    class MDppDensityDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MDppDensityDomain.ClosedOrDense, value: "Closed or Dense" },
                    { key: MDppDensityDomain.MidDense, value: "Mid-dense" },
                    { key: MDppDensityDomain.SparseOrOpen, value: "Sparse or Open" },
                    { key: MDppDensityDomain.VerySparse, value: "Very Sparse" },
                    { key: MDppDensityDomain.Isolated, value: "Isolated" },
                    { key: MDppDensityDomain.None, value: "None" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MDppDensityDomain.ClosedOrDense] = 0;
                this.KeyIndex[MDppDensityDomain.MidDense] = 1;
                this.KeyIndex[MDppDensityDomain.SparseOrOpen] = 2;
                this.KeyIndex[MDppDensityDomain.VerySparse] = 3;
                this.KeyIndex[MDppDensityDomain.Isolated] = 4;
                this.KeyIndex[MDppDensityDomain.None] = 5;
                this.ValueIndex = {};
                this.ValueIndex["Closed or Dense"] = 0;
                this.ValueIndex["Mid-dense"] = 1;
                this.ValueIndex["Sparse or Open"] = 2;
                this.ValueIndex["Very Sparse"] = 3;
                this.ValueIndex["Isolated"] = 4;
                this.ValueIndex["None"] = 5;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MDppDensityDomain = MDppDensityDomain;
    Object.defineProperty(MDppDensityDomain, "ClosedOrDense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MDppDensityDomain, "MidDense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MDppDensityDomain, "SparseOrOpen", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MDppDensityDomain, "VerySparse", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MDppDensityDomain, "Isolated", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MDppDensityDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MDppDensityDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
